import { StyledStrategyInformation, StyledStrategyInformationContent, StyledStrategyInformationHeader } from './strategies.styles';
import type { StrategyInformationProps } from './strategies.d';

export const StrategyInformation = (props: StrategyInformationProps) => (
    <StyledStrategyInformation>
        <StyledStrategyInformationHeader>{props.header}</StyledStrategyInformationHeader>
        <StyledStrategyInformationContent>{props.children}</StyledStrategyInformationContent>
    </StyledStrategyInformation>
);
